export default {
    namespaced: true,
    state: {
        referer: '',
        isRedirectToFaqPage: false,
    },
    mutations: {
        setReferer(state, refererUrl) {
            state.referer = refererUrl;
        },
        setRedirectToFaqPage(state, status) {
            state.isRedirectToFaqPage = status
        },
    },
};
